import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../../../environments/environment';
import { RedeemRequest } from '../../../types/types';
declare var require: any;
const Swal = require('sweetalert2');

@Component({
  selector: 'app-re-enable-qr',
  templateUrl: './re-enable-qr.component.html',
  styleUrls: ['./re-enable-qr.component.scss']
})
export class ReEnableQrComponent implements OnInit {

  // Passed in by the caller (the redeem requests list row).
  redeemRequest: RedeemRequest = undefined;

  @Output() done: EventEmitter<void> = new EventEmitter();

  loading = false;
  working = false;
  canDeleteCustomer = false;   // true only when this is the customer's only scan
  otherScanCount = 0;

  constructor(private http: HttpClient, private toastr: ToastrService, public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    this.loadScanInfo();
  }

  /** Fetch whether the customer has other scans (decides if we may delete them). */
  loadScanInfo(): void {
    this.loading = true;
    this.http.get<any>(`${environment.serverUrl}/redeem-request/${this.redeemRequest.id}/scan-info`).subscribe({
      next: (info) => {
        this.loading = false;
        this.otherScanCount = info?.otherScanCount || 0;
        this.canDeleteCustomer = !!info?.canDeleteCustomer;
      },
      error: (e) => {
        this.loading = false;
        console.error('scan-info failed', e);
        this.toastr.error(e?.error?.error || e?.message || 'Could not load scan details', 'Error');
      }
    });
  }

  get customerName(): string {
    return this.redeemRequest?.customer?.name || '(no customer)';
  }

  get mobile(): string {
    const c: any = this.redeemRequest?.customer;
    return c?.mobileNumber || c?.mobileNumber2 || '';
  }

  reEnable(): void {
    if (this.loading || this.working) { return; }

    if (this.canDeleteCustomer) {
      // Only this customer's scan -> offer to delete the customer too.
      Swal.fire({
        title: 'Re-enable this QR code?',
        html: `QR <strong>${this.redeemRequest.qrCode}</strong> will be re-enabled and this scan deleted.<br>` +
              `<strong>${this.customerName}</strong> has no other scans.`,
        icon: 'warning',
        showCancelButton: true,
        showDenyButton: true,
        confirmButtonText: 'Re-enable & delete customer',
        denyButtonText: 'Only re-enable',
        cancelButtonText: 'Cancel',
        confirmButtonColor: '#d33',
        denyButtonColor: '#3085d6'
      }).then((result: any) => {
        if (result.isConfirmed) { this.submit(true); }
        else if (result.isDenied) { this.submit(false); }
      });
    } else {
      // Customer has previous scans -> re-enable only, cannot delete customer.
      Swal.fire({
        title: 'Re-enable this QR code?',
        html: `QR <strong>${this.redeemRequest.qrCode}</strong> will be re-enabled and this scan deleted.<br>` +
              `<span style="color:#d33">The customer can't be deleted because they have ${this.otherScanCount} previous scan(s).</span>`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Re-enable',
        cancelButtonText: 'Cancel',
        confirmButtonColor: '#3085d6'
      }).then((result: any) => {
        if (result.value) { this.submit(false); }
      });
    }
  }

  private submit(deleteCustomer: boolean): void {
    this.working = true;
    this.http.post<any>(`${environment.serverUrl}/redeem-request/${this.redeemRequest.id}/re-enable`,
      JSON.stringify({ deleteCustomer })).subscribe({
      next: (res) => {
        this.working = false;
        const parts = ['QR code re-enabled'];
        if (res?.customerDeleted) { parts.push('customer deleted'); }
        this.toastr.success(parts.join(' · '), 'Done', { timeOut: 5000, positionClass: 'toast-top-full-width' });
        this.done.emit();
        this.activeModal.close('reenabled');
      },
      error: (e) => {
        this.working = false;
        console.error('re-enable failed', e);
        this.toastr.error(e?.error?.error || e?.message || 'Failed to re-enable QR code', 'Error');
      }
    });
  }
}
